import { aes_gcm_encrypt, aes_gcm_decrypt } from "crypto-aes-gcm";

// Function to encrypt data using AES-GCM
const passPhrase = "HUBZU_LOGIN";

export const encrypt = async (data, phraseToPass) => {
  const encrypted = await aes_gcm_encrypt(data, phraseToPass || passPhrase);
  return encrypted;
};
export const decrypt = async (data, phraseToPass) => {
  const decrypted = await aes_gcm_decrypt(data, phraseToPass || passPhrase);
  return decrypted;
};

// crypto.js
// export const decrypt2 = async (encryptedData) => {
//   try {
//     // Split the encrypted data by '=='
//     const parts = encryptedData.split("==");

//     // Process each part
//     const processedParts = [];
//     for (let i = 0; i < parts.length; i++) {
//       if (parts[i]) {
//         // Add back the padding for all parts except possibly the last
//         const part = i < parts.length - 1 ? parts[i] + "==" : parts[i];
//         processedParts.push(part);
//       }
//     }

//     // Decrypt each part
//     const decryptedParts = [];
//     for (const part of processedParts) {
//       try {
//         // Replace URL-safe characters
//         let sanitizedPart = part.replace(/-/g, "+").replace(/_/g, "/");

//         // Add padding if necessary
//         const pad = sanitizedPart.length % 4;
//         if (pad) {
//           sanitizedPart += "=".repeat(4 - pad);
//         }

//         const decryptedPart = await aes_gcm_decrypt(sanitizedPart, passPhrase);
//         decryptedParts.push(decryptedPart);
//       } catch (partError) {
//         console.error("Failed to decrypt part:", part);
//         throw partError;
//       }
//     }

//     // Join all decrypted parts
//     return decryptedParts.join("");
//   } catch (error) {
//     console.error("Decryption process failed:", error);
//     throw error;
//   }
// };
// // Helper function to validate Stripe client secret format
// const isValidStripeClientSecret = (text) => {
//   return text.startsWith("pi_") && text.includes("_secret_");
// };

// // Use this in your component
// export const decryptClientSecret = async (encryptedData) => {
//   try {
//     const decrypted = await decrypt2(encryptedData);

//     if (!isValidStripeClientSecret(decrypted)) {
//       throw new Error("Invalid client secret format");
//     }

//     return decrypted;
//   } catch (error) {
//     console.error("Client secret decryption failed:", error);
//     throw error;
//   }
// };
const sanitizeBase64 = (str) => {
  // Remove any whitespace
  let clean = str.replace(/\s/g, "");

  // Split the string at '==' if present
  const parts = clean.split("==");

  // Take only the first part and add proper padding
  clean = parts[0];

  // Replace URL-safe characters
  clean = clean.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding to make length multiple of 4
  const pad = clean.length % 4;
  if (pad) {
    clean += "=".repeat(4 - pad);
  }

  return clean;
};

export const decrypt2 = async (encryptedData) => {
  try {
    // Log original data
    console.log("Original encrypted data:", encryptedData);

    // Clean and format the base64 string
    const sanitizedData = sanitizeBase64(encryptedData);
    console.log("Sanitized data:", sanitizedData);

    // Verify it's a valid base64 string
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(sanitizedData)) {
      throw new Error("Invalid base64 format after sanitization");
    }

    // Attempt decryption
    const decrypted = await aes_gcm_decrypt(sanitizedData, passPhrase);
    console.log("Decryption successful");

    return decrypted;
  } catch (error) {
    console.error("Decryption process failed:", error);
    throw error;
  }
};
export const decryptClientSecret = async (encryptedData) => {
  if (!encryptedData) {
    throw new Error("No encrypted data provided");
  }

  try {
    console.log("Starting decryption of:", encryptedData);

    const decrypted = await decrypt2(encryptedData);

    // Validate the decrypted result
    if (typeof decrypted !== "string") {
      throw new Error("Decryption resulted in invalid data type");
    }

    if (!decrypted.startsWith("pi_")) {
      throw new Error("Decrypted data is not a valid Stripe client secret");
    }

    return decrypted;
  } catch (error) {
    console.error("Client secret decryption failed:", error);
    throw error;
  }
};
